var map = {
	"./login/login.module": [
		"./src/app/auth/login/login.module.ts",
		"login-login-module"
	],
	"src/app/main/announcement/announcement.module": [
		"./src/app/main/announcement/announcement.module.ts",
		"src-app-main-announcement-announcement-module"
	],
	"src/app/main/blog/blog.module": [
		"./src/app/main/blog/blog.module.ts",
		"src-app-main-blog-blog-module"
	],
	"src/app/main/carnival-management/carnival-management.module": [
		"./src/app/main/carnival-management/carnival-management.module.ts",
		"src-app-main-carnival-management-carnival-management-module"
	],
	"src/app/main/category-management/category-management.module": [
		"./src/app/main/category-management/category-management.module.ts",
		"src-app-main-category-management-category-management-module"
	],
	"src/app/main/contests/contests.module": [
		"./src/app/main/contests/contests.module.ts",
		"src-app-main-contests-contests-module"
	],
	"src/app/main/dashboard/dashboard.module": [
		"./src/app/main/dashboard/dashboard.module.ts",
		"src-app-main-dashboard-dashboard-module"
	],
	"src/app/main/event-announcement/event-announcement.module": [
		"./src/app/main/event-announcement/event-announcement.module.ts",
		"src-app-main-event-announcement-event-announcement-module"
	],
	"src/app/main/group-management/group-management.module": [
		"./src/app/main/group-management/group-management.module.ts",
		"common",
		"src-app-main-group-management-group-management-module"
	],
	"src/app/main/notification/notification.module": [
		"./src/app/main/notification/notification.module.ts",
		"common",
		"src-app-main-notification-notification-module"
	],
	"src/app/main/report-management/report-management.module": [
		"./src/app/main/report-management/report-management.module.ts",
		"src-app-main-report-management-report-management-module"
	],
	"src/app/main/reward-management/reward-management.module": [
		"./src/app/main/reward-management/reward-management.module.ts",
		"src-app-main-reward-management-reward-management-module"
	],
	"src/app/main/user-management/user-management.module": [
		"./src/app/main/user-management/user-management.module.ts"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;